import { useEffect, useState } from 'react';

import { useEvent } from '@hooks/use-event';

import { DynamicFieldsProvider } from './context';
import { RenderDynamicField } from './render-field';
import { Field } from './types';
import { addRepeatingEntry, bootstrapForm, removeRepeatingEntry } from './utils';

import { FormExternalConditionData } from '../types';

export type DynamicFieldsProps = {
  initialFields: Array<Field>;
  onFieldsUpdate(newFields: Array<Field>): void;

  // For conditional fields relying on external data
  externalConditionData?: FormExternalConditionData;
};

export const FormDynamicFields = ({
  initialFields,
  externalConditionData,
  onFieldsUpdate: onFieldsChange,
}: DynamicFieldsProps) => {
  const [fields, setFields] = useState(() => bootstrapForm(initialFields));

  const addRepeatingFieldEntry = useEvent((id: string) => {
    setFields((old) => addRepeatingEntry(id, old));
  });

  const removeRepeatingFieldEntry = useEvent((id: string) => {
    setFields((old) => removeRepeatingEntry(id, old));
  });

  useEffect(() => {
    onFieldsChange(fields);
  }, [fields, onFieldsChange]);

  return (
    <DynamicFieldsProvider
      value={{
        addRepeatingFieldEntry,
        removeRepeatingFieldEntry,
      }}
    >
      {fields.map((field) => (
        <RenderDynamicField key={field.id} externalData={externalConditionData} field={field} />
      ))}
    </DynamicFieldsProvider>
  );
};
